import {debounce, math} from "./Utils";
import Swiper, {Pagination} from 'swiper';
import gsap from "gsap";

Swiper.use([Pagination]);

class SliderFounders {
	static instance = null;

	static create(options) {
		if (SliderFounders.instance === null) {
			if (options) {
				SliderFounders.instance = new SliderFounders(options);
			}

			return SliderFounders.instance;
		}
	}

	static destroy() {
		if (SliderFounders.instance) {
			SliderFounders.instance.beforeDestroy();
			SliderFounders.instance = null;
		}
	}

	static get defaultOptions() {
		return {
			selector: null,
			container: document,
			next: "",
			prev: "",
			pagination:".swiper-pagination",
			unblurAmount: 3,
			namespace: 'home',
		};
	}

	constructor(options) {
		this.options = Object.assign({}, SliderFounders.defaultOptions, options);
		const these = this;
		this.resize();
		this.initEvents();
		this.firstMove = true;
		this.speed = parseFloat(this.options.selector.getAttribute('data-speed-slide'))

		this.slider = new Swiper(this.options.selector, {
			slidesPerView: 1.098,
			spaceBetween: 33,
			slidesPerGroup: 1,
			loop: true,
			setWrapperSize: true,
			roundLengths: true,
			grabCursor: true,
			watchSlidesProgress: true,
			loopPreventsSlide: true, //false for fast clicking
			mousewheel: false,
			speed: this.options.mobileSpeed || these.speed,
			loopFillGroupWithBlank: true,

			pagination: {
				el: this.options.pagination,
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					const totalSlides = parseInt(swiper.el.dataset.foundersCount);
					const perView = these.getSlidesPerGroup(swiper);
					const totalPages = Math.ceil(totalSlides / perView);
					const currentSlide = current <= totalPages ? current : (current % totalPages || totalPages);
					return ('0' + currentSlide).slice(-2) + '/' + (`0${totalPages}`).slice(-2);
				},
			},
			navigation: {
				nextEl: this.options.next,
				prevEl: this.options.prev,
			},
			breakpoints: this.options.breakpoints || {
				768: {
					slidesPerView: 2,
					spaceBetween: 64,
					slidesPerGroup: 2,
					speed: these.speed,

				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 64,
					slidesPerGroup: 2,
					speed: these.speed,

				},
				1280: {
					slidesPerView: 5,
					spaceBetween: 116,
					slidesPerGroup: 3,
					speed: these.speed,
				}
			},
			on: {
				beforeInit: function (swiper) {
					if (swiper.el.querySelectorAll('.swiper-slide').length == 0) return;
					if (swiper.slides.length < 3)
						for (let index = 0; index < 2; index++) {
							swiper.el.querySelectorAll('.swiper-slide').forEach(function (element) {
								let clone = element.cloneNode(true);
								swiper.el.querySelectorAll('.swiper-wrapper')[0].appendChild(clone);
							});
						}

				},
				init: (swiper) => {
					const speed = these.speed / 1000,
						delay = 2 * these.speed / 1000;


					these.handleClickBlurImage(swiper)

					if(this.options.namespace == 'home' || this.options.namespace == 'home-india' || this.options.namespace == 'focus-area'){
						switch (these.breakpoint) {
							case 'desktop' :
								gsap.set(this.options.selector, {x: -115});
								gsap.to(this.options.selector, {
									x: 0, duration: speed, delay: delay, onComplete: () => {
										this.firstMove = false;
									}
								})
								break;
	
							case 'tablet' :
								gsap.set(this.options.selector, {x: -72});
								gsap.to(this.options.selector, {
									x: 0, duration: speed, delay: delay, onComplete: () => {
										this.firstMove = false;
									}
								})
								break;
						}
					}
				},
				progress: (e, globalProgress,unblurAmount = this.options.unblurAmount) => {
					for (let r = 0; r < e.slides.length; r += 1) {
						const slide = e.slides[r].firstElementChild;
						let progress = e.slides[r].progress;
						let progressAbs = Math.abs(progress);
						let blurAmount = 0;


						switch (these.breakpoint) {
							case 'uhd':
								if (progress <= -1 && progress >= -unblurAmount) {
									blurAmount = 0;
								} else {
									if (progress >= 0 || progress <= -(unblurAmount + 1)) {
										blurAmount = 10;
									} else if (progress >= -(unblurAmount + 1) && progress < -unblurAmount) {
										blurAmount = math.lerp(0, 10, (progressAbs - unblurAmount) / 1);
									} else if (progress > -1 && progress < 0) {
										blurAmount = math.lerp(10, 0, progressAbs);
									}
								}
								break;
				
							case 'widescreen':
								if (progressAbs >= 0.7 && progressAbs <= unblurAmount) {
									blurAmount = 0;
								} else {
									if (progressAbs >= (unblurAmount + 1) || progressAbs <= 0) {
										blurAmount = 10;
									} else if (progressAbs >= unblurAmount && progressAbs < (unblurAmount + 1)) {
										blurAmount = math.lerp(0, 10, (progressAbs - unblurAmount) / 0.5);
									} else if (progressAbs > 0 && progressAbs < 0.7) {
										blurAmount = math.lerp(10, 0, progressAbs / 0.7);
									}
								}
								break;

							case 'desktop':
								if (this.options.namespace == 'home' || this.options.namespace == 'home-india' || this.options.namespace == 'focus-area') {
									if (progress <= 0 && progress >= -1) {
										blurAmount = 0;
									} else {
										if (progress >= 0.5 || progress <= -1.5) {
											blurAmount = 10;
										} else if (progress > 0 && progress < 0.5) {
											blurAmount = math.lerp(0, 10, progress / 0.5);
										} else if (progress > -1.5 && progress < -1) {
											blurAmount = math.lerp(10, 0, (progress + 1.5) / 0.5);
										}
									}
								} else {
									if (progress <= -1 && progress >= -3) {
										blurAmount = 0;
									} else {
										if (progress >= 0 || progress <= -(3 + 1)) {
											blurAmount = 10;
										} else if (progress >= -(3 + 1) && progress < -3) {
											blurAmount = math.lerp(0, 10, (progressAbs - 3) / 1);
										} else if (progress > -1 && progress < 0) {
											blurAmount = math.lerp(10, 0, progressAbs);
										}
									}
								}
								break;

							case 'tablet':
								if (this.options.namespace == 'home' || this.options.namespace == 'home-india' || this.options.namespace == 'focus-area') {
									if (progress <= 0 && progress >= -1) {
										blurAmount = 0;
									} else {
										if (progress >= 0.5 || progress <= -1.5) {
											blurAmount = 10;
										} else if (progress > 0 && progress < 0.5) {
											blurAmount = math.lerp(0, 10, progress / 0.5);
										} else if (progress > -1.5 && progress < -1) {
											blurAmount = math.lerp(10, 0, (progress + 1.5) / 0.5);
										}
									}
								} else {
									if (progress <= -1 && progress >= -2) {
										blurAmount = 0;
									} else {
										if (progress >= 0 || progress <= -(2 + 1)) {
											blurAmount = 10;
										} else if (progress >= -(2 + 1) && progress < -2) {
											blurAmount = math.lerp(0, 10, (progressAbs - 2) / 1);
										} else if (progress > -1 && progress < 0) {
											blurAmount = math.lerp(10, 0, progressAbs);
										}
									}
								}
								break;

							case 'phone':
								if (progress < 0.25 && progress > -0.25) {
									blurAmount = 0;
								} else {
									if (progress >= 0.75 || progress <= -0.75) {
										blurAmount = 10;
									} else if (progress >= 0.25 && progress < 0.75) {
										blurAmount = math.lerp(0, 10, (progress - 0.25) / 0.5);
									} else if (progress > -0.75 && progress < -0.25) {
										blurAmount = math.lerp(10, 0, (progress + 0.75) / 0.5);
									}
								}
								break;

							default:
								blurAmount = 0;
								break;
						}

						if (blurAmount > 0) {
							slide.style.filter = `blur(${Math.floor(blurAmount)}px)`;
							slide.parentElement.classList.remove('swiper-enable-link')
							slide.parentElement.classList.add('swiper-disable-link')
							slide.classList.remove('swiper-enable-link')
							slide.classList.add('swiper-disable-link')
						} else {
							slide.style.filter = 'none';

							if (!slide.parentElement.classList.contains('swiper-slide-duplicate')) {
								slide.parentElement.classList.add('swiper-enable-link')
								slide.parentElement.classList.remove('swiper-disable-link')
								slide.classList.add('swiper-enable-link')
								slide.classList.remove('swiper-disable-link')
							} else {
								slide.parentElement.classList.remove('swiper-enable-link')
								slide.parentElement.classList.add('swiper-disable-link')
								slide.classList.remove('swiper-enable-link')
								slide.classList.add('swiper-disable-link')
							}

						}
					}
				},
				setTransition(e, t) {
					for (let r = 0; r < e.slides.length; r += 1) {
						const o = e.slides[r].firstElementChild;
						o.style.transitionDuration = `${t}ms`;
					}
				},

				slideChange: (swiper) => {
					this.handleClickBlurImage(swiper)
				},

				fromEdge(swiper) {
					if (swiper.isBeginning) {
						swiper.slideNext();
					}
					if (swiper.isEnd) {
						swiper.slidePrev();
					}

				}

			}
		});

		this.slider.on('sliderFirstMove', () => {
			switch (these.breakpoint) {
				case 'desktop' :
				case 'tablet' :
					if (!!this.firstMove) {
						this.firstMove = false;
						gsap.to(this.options.selector, {x: 0, duration: these.speed / 1000})
					}
					break;
			}
		});
	}

	getSlidesPerGroup(swiper) {
		const breakpoint = swiper.params.breakpoints;
		const currentBreakpointArray = Object.keys(breakpoint).filter((breakpoint) => {
			const breakpointText = '(min-width: ' + breakpoint + 'px)';
			if (window.matchMedia(breakpointText).matches) {
				return breakpoint;
			}
		})
		const currentBreakpoint = currentBreakpointArray.length ? currentBreakpointArray[currentBreakpointArray.length - 1] : false;
		return currentBreakpoint ? breakpoint[currentBreakpoint].slidesPerGroup : 1;
	}

	handleClickBlurImage(swiper) {


		let
			prevButton = '',
			nextButton = '',
			AllPrevButton = [],
			AllNextButton = [];
		prevButton = swiper.slides[swiper.activeIndex + 1];
		nextButton = swiper.slides[swiper.activeIndex];

		let slides = swiper.slides;

		switch (this.breakpoint) {
			case 'uhd' :
				nextButton = swiper.slides[swiper.activeIndex + 3];
				break;
			case 'widescreen' :
				nextButton = swiper.slides[swiper.activeIndex + 3];
				break;
			case 'desktop' :
			case 'tablet' :
				prevButton = swiper.slides[swiper.activeIndex];
				nextButton = swiper.slides[swiper.activeIndex + 1];
				break;
			case 'phone' :
				prevButton = swiper.slides[swiper.activeIndex - 1];
				break;
		}

		AllPrevButton = this.getAllSiblings(prevButton, 'prev');
		AllNextButton = this.getAllSiblings(nextButton, 'next');

		AllNextButton.forEach(el => {
			el.classList.remove('slide-blur-prev');
			el.firstElementChild.classList.remove('slide-blur-prev');
			el.classList.add('slide-blur-next');
			el.firstElementChild.classList.add('slide-blur-next');
		})
		AllPrevButton.forEach(el => {
			el.classList.remove('slide-blur-next');
			el.classList.add('slide-blur-prev');
			el.firstElementChild.classList.remove('slide-blur-next');
			el.firstElementChild.classList.add('slide-blur-prev');
		})

		setTimeout(() => {
			slides.forEach(el => {
				$(el.firstElementChild).off('click');
				if (el.matches(".slide-blur-prev.swiper-disable-link")) {
					$(el.firstElementChild).off().on('click', function (e) {
						e.preventDefault();
						swiper.slidePrev();
					})
				}

				if (el.matches(".slide-blur-next.swiper-disable-link")) {
					$(el.firstElementChild).off().on('click', function (e) {
						e.preventDefault();
						swiper.slideNext();
					})
				}
			})

		}, 100)
	}

	getAllSiblings(target, navigation) {
		var result = [],
			node = target;
		while (node) {
			if (node !== target && node.nodeType === Node.ELEMENT_NODE)
				result.push(node);
			switch (navigation) {
				case 'prev':
				case 'previous':
					node = node.previousElementSibling || node.previousSibling;
					break;
				case 'next':
					node = node.nextElementSibling || node.nextSibling;
					break;

				default:
					break;
			}
		}
		return result;
	}

	getBreakpoint() {
		const breakpoints = {
			'(min-width: 1024px) and (max-width: 1279.98px)': 'desktop',
			'(min-width: 768px) and (max-width: 1023.98px)': 'tablet',
			'(max-width: 767.98px)': 'phone',
			'(min-width: 1280px) and (max-width: 1920px)': 'widescreen',
			'(min-width: 1921px)': 'uhd',
		}

		for (let media in breakpoints) {
			if (window.matchMedia(media).matches) {
				return breakpoints[media];
			}
		}

		return null;
	}

	initEvents() {
		this.onResize = debounce(this.resize.bind(this), 100);
		window.addEventListener('resize', this.onResize);
	}

	resizeHandler() {
		const breakpoint = this.getBreakpoint();
		if (this.breakpoint !== breakpoint) {
			this.breakpoint = breakpoint;
			if (this.slider) {
				this.slider.update();
			}
		}
	}

	resize() {
		const width = window.innerWidth;
		if (this.width !== width) {
			this.width = width;
			this.resizeHandler();
		}
	}

	beforeDestroy() {
		this.slider.destroy();
		window.removeEventListener('resize', this.onResize);
		this.breakpoint = null;
		this.width = null;
		this.slider = null;
	}
}

export default SliderFounders;
